<!--This layout will be used whenever we need a vue where user is not autheticated-->
<!--Basic usage are: Login, Register, Reset password-->

<template>
  <div class="flex justify-center items-center min-h-screen">
    <div class="w-full sm:w-1/3 mx-auto my-0">
      <div class="flex justify-center">
        <img class="w-44" src="/images/logo.png" />
      </div>
      <div class="layout-container bg-white rounded mt-3">
        <div class="view-header w-full flex justify-center items-center">
          <span class="text-3xl font-light">Login</span>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AuthenticationLayout',
});
</script>

<style scoped>
.layout-container {
  box-shadow: 0 1rem 3rem rgb(0 0 0 /18%);
}

.view-header {
  background: rgba(0, 0, 0, 0.03);
  height: 100px;
}
</style>
